import apiClient from 'apiClient';
import { ValidationResponse, ValidationStatuses } from './types';

export class CheckRegionAvailabilityForTioError extends Error {}

const checkRegionAvailabilityForTio = async (postCode: string): Promise<ValidationResponse> => {
  const response = await apiClient.post('/api/v1/business-rules/check-region-availability-for-tio', {
    postCode,
  });

  if (response.data.status !== ValidationStatuses.OK) {
    throw new CheckRegionAvailabilityForTioError(
      'Unfortunately, we are unable to lend against a property in this location.',
    );
  }

  return response.data;
};

export default checkRegionAvailabilityForTio;
